import * as React from 'react';
import type { SVGProps } from 'react';
const SvgRows2 = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" fill="none" viewBox="0 0 24 24" {...props}>
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M4.75 5.75v.5a1 1 0 0 0 1 1h12.5a1 1 0 0 0 1-1v-.5a1 1 0 0 0-1-1H5.75a1 1 0 0 0-1 1M4.75 11.75v.5a1 1 0 0 0 1 1h12.5a1 1 0 0 0 1-1v-.5a1 1 0 0 0-1-1H5.75a1 1 0 0 0-1 1M4.75 17.75v.5a1 1 0 0 0 1 1h12.5a1 1 0 0 0 1-1v-.5a1 1 0 0 0-1-1H5.75a1 1 0 0 0-1 1"
    />
  </svg>
);
export default SvgRows2;
